import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const SMSHandler = {
  sendInvitationSMS: function (leadSn,tutorChatToken,providerId,phone,QRCodeLink) {
    var sendResult_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/SendInvitationSMS",
      type: "post",
      cache: false,
      async: false,
      data: {
        leadSn: leadSn,
        tutorChatToken: tutorChatToken,
        ProviderId: providerId,
        PhoneNumber:phone,
        QRCodeLink:QRCodeLink
      },
      dataType: "json",
      success: function (data) {
        sendResult_ = data.Success;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return sendResult_;
  },
};



// WEBPACK FOOTER //
// ./src/handler/SMSHandler.js